// https://www.hivemq.com/blog/mqtt-client-library-mqtt-js/
// https://github.com/mqttjs/MQTT.js
// import * as constants from '@/util/constants'
import bus from '@/util/eventbus'
import { CLIENT_WECHAT_MINI } from '../../../util/constants'
let mqtt = require('mqtt')
// let mqtt = require('@/plugins/mqttjs')
let util = require('@/util/util')
let constants = require('@/util/constants')
let messageProto = require('@/protobuf/message_pb')
// import * as protobuf from 'google-protobuf'
let types = require('./mutation-types')
// let bus = require('@/util/eventbus')

let mqttClient
let mqttConnected
let mqttConnectTimes = 0
// let networkConnected = true
// let noteMap = new Map()

export const mqttConnect = ({ commit, rootState, dispatch }) => {
  // 避免重复连接
  if (mqttConnected) {
    console.log('already connected, return')
    return
  }
  if (!constants.IS_PRODUCTION) {
    console.log('connecting to mqtt')
  }
  mqttConnectTimes += 1
  // 更新连接状态: 连接中...
  let connectionStatus = constants.STOMP_CONNECTION_STATUS_CONNECTING
  commit(types.UPDATE_USER_CONNECTION, { connectionStatus }, { root: true })
  bus.$emit(constants.EVENT_BUS_STOMP_CONNECTION_STATUS, connectionStatus)
  //
  var clientId = rootState.user.info.uid + '/' + constants.HTTP_CLIENT
  //
  if (constants.IS_PRODUCTION) {
    // WSS
    var options = {
      username: rootState.user.info.username,
      password: '',
      keepalive: 60, // seconds, set to 0 to disable
      clientId: clientId,
      protocolId: 'MQTT',
      protocolVersion: 4,
      clean: true,
      reconnectPeriod: 1000, // milliseconds, interval between two reconnections. Disable auto reconnect by setting to 0.
      connectTimeout: 10 * 1000, // milliseconds, time to wait before a CONNACK is received
      // will: {
      //   topic: 'WillMsg',
      //   payload: 'Connection Closed abnormally..!',
      //   qos: 0,
      //   retain: false
      // },
      reschedulePings: true,
      rejectUnauthorized: false
    }
    mqttClient = mqtt.connect(constants.MQTT_HOST, options)
  } else {
    // WS连接
    mqttClient = mqtt.connect({
      username: rootState.user.info.username,
      password: '', // TODO: 填写真正密码
      keepalive: 60, // seconds, set to 0 to disable
      clientId: clientId,
      protocolId: 'MQTT',
      protocolVersion: 4,
      clean: true,
      reconnectPeriod: 1000, // milliseconds, interval between two reconnections. Disable auto reconnect by setting to 0.
      connectTimeout: 10 * 1000, // milliseconds, time to wait before a CONNACK is received
      port: constants.MQTT_PORT, // 通过websocket连接mqtt
      host: constants.MQTT_WS_HOST,
      path: '/websocket',
      // encoding: 'binary',
      // will: {
      //   topic: 'protobuf/lastWill/mqtt',
      //   payload: '',
      //   qos: 1,
      //   retain: false
      // },
      reschedulePings: true,
      rejectUnauthorized: false
    })
  }
  //
  mqttClient.on('connect', function () {
    if (!constants.IS_PRODUCTION) {
      console.log('connected to mqtt')
    }
    mqttConnected = true
    // 更新连接状态：连接成功
    let connectionStatus = constants.STOMP_CONNECTION_STATUS_CONNECTED
    commit(types.UPDATE_USER_CONNECTION, { connectionStatus }, { root: true })
    bus.$emit(constants.EVENT_BUS_STOMP_CONNECTION_STATUS, connectionStatus)
    // 延迟执行
    setTimeout(function () {
      // TODO: 重连成功之后，拉取缓存消息
      // 拉取会话
      dispatch('getThreads', {}, { root: true })
      // TODO: 本地缓存消息中处于发送状态的消息，不断重试发送
      for (let i = 0; i < rootState.user.protobufMessages.length; i++) {
        const message = rootState.user.protobufMessages[i]
        if (message.status === constants.MESSAGE_STATUS_SENDING) {
          let content = ''
          if (message.type === constants.MESSAGE_TYPE_TEXT) {
            content = message.content
          } else if (message.type === constants.MESSAGE_TYPE_IMAGE) {
            content = message.imageUrl
          } else if (message.type === constants.MESSAGE_TYPE_FILE) {
            content = message.fileUrl
          } else {
            content = message.content
          }
          // 重新发送
          // console.log('resend', message.mid, content)
          let localPayload = { mid: message.mid, content: content, type: message.type, thread: message.thread }
          doSendMessageProtobuf({ commit, rootState, dispatch }, localPayload)
        }
      }
    }, 5000);
    // TODO: 重连成功之后，拉取未读消息
    let payload = { page: 0, size: 20 }
    dispatch('getUnreadMessagesAgent', payload, { root: true })
  })
  //
  mqttClient.on('message', function (topic, messageBinary) {
    // 解析protobuf, 解密消息内容
    let messageProtobuf = messageProto.Message.deserializeBinary(messageBinary)
    //
    let uid = messageProtobuf.getUser().getUid()
    // console.log('uid:', uid)
    let nickname = messageProtobuf.getUser().getNickname()
    let avatar = messageProtobuf.getUser().getAvatar()
    //
    let mid = messageProtobuf.getMid()
    // 判断是否加密
    let content = ''
    let type = messageProtobuf.getType()
    let timestamp = messageProtobuf.getTimestamp()
    let client = messageProtobuf.getClient()
    // console.log('receive mqtt message: type ', type, ' client:', client)
    // 非会话消息，如：会议通知等, 另行处理
    if (type === constants.MESSAGE_TYPE_NOTIFICATION_NOTICE) {
      let message = {
        mid: mid,
        timestamp: timestamp,
        client: client,
        type: type,
        user: {
          uid: uid,
          nickname: nickname,
          avatar: avatar
        },
        notice: {
          topic: messageProtobuf.getNotice().getTopic(),
          type: messageProtobuf.getNotice().getType(),
          content: messageProtobuf.getNotice().getContent()
        }
      }
      // TODO: 发送送达、已读回执
      // console.log('notice ', message)
      bus.$emit(constants.EVENT_BUS_MESSAGE_NOTICE, message)
      return
    } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_CHANNEL) {
      // 推送频道消息: 营销消息、系统通知、加好友通知、赞/收藏(当别人赞/收藏了自己的帖子时发生通知)
      console.log('MESSAGE_TYPE_NOTIFICATION_CHANNEL')
    }
    // 持久化
    // 会话列表中显示同一个用户的多条会话
    let visitorUid = messageProtobuf.getThread().getTopic().split('/')[1] // 访客uid
    var thread = {
      tid: messageProtobuf.getThread().getTid(),
      type: messageProtobuf.getThread().getType(),
      uid: uid, // 注意：最新消息发送者的uid，可以是当前客服uid或访客uid
      nickname: rootState.user.note_map.has(visitorUid) ? rootState.user.note_map.get(visitorUid) : messageProtobuf.getThread().getNickname(),
      avatar: messageProtobuf.getThread().getAvatar(),
      content: messageProtobuf.getThread().getContent(), // 收到的会话的最新消息，可以是当前客服uid或访客uid
      timestamp: messageProtobuf.getThread().getTimestamp(),
      unreadCount: messageProtobuf.getThread().getUnreadcount(),
      topic: messageProtobuf.getThread().getTopic(),
      // 之前老版本没有thread.client字段，故判断下
      client: (messageProtobuf.getThread().getClient() === undefined || messageProtobuf.getThread().getClient() === null) ? client : messageProtobuf.getThread().getClient(),
      // client: client // FIXME: 应该为thread的client，但显示的是最新消息发送者的client，包括当前客服client
    }
    // 本地持久化， TODO: 统一本地消息结构体
    if (visitorUid === uid && rootState.user.note_map.has(visitorUid)) {
      nickname = rootState.user.note_map.get(visitorUid)
    }
    let message = {
      mid: mid,
      content: content,
      imageUrl: content,
      voiceUrl: content,
      length: 0,
      // video
      videoOrShortUrl: content,
      // file
      fileUrl: content,
      // location
      lablel: content,
      scale: '',
      locationX: '',
      locationY: '',
      // link
      title: content,
      description: '',
      url: '',
      //
      createdAt: timestamp,
      client: client,
      type: type,
      status: constants.MESSAGE_STATUS_STORED,
      thread: thread,
      user: {
        uid: uid,
        nickname: nickname,
        avatar: avatar
      }
    }
    // 是否发送消息回执
    // let autoReply = false
    // let isCloseThread = false
    let sendReceipt = false
    let webRTCVideoInvite = false
    let webRTCAudioInvite = false
    switch (type) {
      //
      case constants.MESSAGE_TYPE_TEXT: {
        // console.log('text:', messageProtobuf.getText())
        // autoReply = true
        sendReceipt = true
        // message.content = messageProtobuf.getEncrypted() ? util.decrypt(messageProtobuf.getText().array[0]) : messageProtobuf.getText().array[0]
        message.content = messageProtobuf.getText().array[0]
        break
      }
      case constants.MESSAGE_TYPE_IMAGE: {
        // console.log('image:', messageProtobuf.getImage())
        // autoReply = true
        sendReceipt = true
        message.imageUrl = messageProtobuf.getImage().array[2]
        break
      }
      case constants.MESSAGE_TYPE_VOICE: {
        // console.log('voice:', messageProtobuf.getVoice())
        // autoReply = true
        sendReceipt = true
        message.voiceUrl = messageProtobuf.getVoice().array[2]
        message.length = messageProtobuf.getVoice().array[3]
        break
      }
      case constants.MESSAGE_TYPE_VIDEO:
      case constants.MESSAGE_TYPE_SHORT_VIDEO: {
        // console.log('video:', messageProtobuf.getVideo())
        sendReceipt = true
        message.videoOrShortUrl = messageProtobuf.getVideo().array[2]
        break
      }
      case constants.MESSAGE_TYPE_FILE: {
        // console.log('file:', messageProtobuf.getFile())
        // autoReply = true
        sendReceipt = true
        message.fileUrl = messageProtobuf.getFile().array[0]
        break
      }
      case constants.MESSAGE_TYPE_CARD: {
        console.log('card:', messageProtobuf.getText())
        sendReceipt = true
        message.content = messageProtobuf.getText().array[0]
        break
      }
      case constants.MESSAGE_TYPE_COMMODITY: {
        sendReceipt = true
        message.content = messageProtobuf.getText().array[0]
        break
      }
      case constants.MESSAGE_TYPE_LOCATION: {
        sendReceipt = true
        message.locationX = messageProtobuf.getLocation().array[0]
        message.locationY = messageProtobuf.getLocation().array[1]
        message.scale = messageProtobuf.getLocation().array[2]
        message.label = messageProtobuf.getLocation().array[3]
        break
      }
      case constants.MESSAGE_TYPE_LINK: {
        sendReceipt = true
        message.title = messageProtobuf.getLink().array[0]
        message.description = messageProtobuf.getLink().array[1]
        message.url = messageProtobuf.getLink().array[2]
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_THREAD: {
        thread.unreadCount += 1
        message.content = messageProtobuf.getText().array[0]
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_THREAD_REENTRY: {
        message.content = messageProtobuf.getText().array[0]
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_CONNECT: {
        // TODO: 用户上线、离线通知，在会话列表中标记/显示
        message.content = messageProtobuf.getText().array[0]
        thread.content = "[上线]" + message.content
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_DISCONNECT: {
        // TODO: 用户上线、离线通知，在会话列表中标记/显示
        message.content = messageProtobuf.getText().array[0]
        thread.content = "[离线]" + message.content
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_AGENT_CLOSE: {
        // isCloseThread = true
        let tid = thread.tid
        commit(types.REMOVE_USER_THREAD, { tid }, { root: true })
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_VISITOR_CLOSE:
      case constants.MESSAGE_TYPE_NOTIFICATION_AUTO_CLOSE: {
        // isCloseThread = true
        message.content = messageProtobuf.getText().array[0]
        // 将会话从’进行中‘迁移到’已结束‘
        let tid = thread.tid
        commit(types.CLOSE_USER_THREAD, { tid }, { root: true })
        commit(types.REMOVE_USER_THREAD, { tid }, { root: true })
        break
      }
      // 新工单
      case constants.MESSAGE_TYPE_NOTIFICATION_TICKET: {
        message.content = messageProtobuf.getText().array[0]
        // 新工单提醒
        if (uid !== rootState.user.info.uid) {
          bus.$emit(constants.EVENT_BUS_SUPPORT_NEW_TICKET, content)
        }
        // return
        break
      }
      // 渠道消息
      case constants.MESSAGE_TYPE_NOTIFICATION_CHANNEL: {
        //
        message.content = messageProtobuf.getText().array[0]
        break
      }
      // 迁移到MESSAGE_TYPE_NOTIFICATION_NOTICE中
      // case constants.MESSAGE_TYPE_NOTIFICATION_QUEUE: {
      //   console.log('排队访客')
      //   // 1.持久化
      //   let queue = message.queue
      //   commit(types.ADD_USER_QUEUE, { queue }, { root: true })
      //   // TODO: 2. 播放提示音
      //   break
      // }
      case constants.MESSAGE_TYPE_NOTIFICATION_QUEUE_ACCEPT: {
        // console.log('排队访客被接入')
        message.content = messageProtobuf.getText().array[0]
        // 排队访客被接入
        // let qid = message.queue.qid
        // commit(types.ACCEPT_USER_QUEUE, { qid }, { root: true })
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_PREVIEW: {
        // TODO:
        let previewContent = messageProtobuf.getPreview().array[0]
        // console.log('消息预知:', previewContent)
        // 首先过滤掉自己发送的
        if (uid !== rootState.user.info.uid) {
          let previewMessage = {
            content: previewContent === undefined ? '' : previewContent,
            thread: {
              tid: messageProtobuf.getThread().getTid()
            }
          }
          bus.$emit(constants.EVENT_BUS_MESSAGE_PREVIEW, previewMessage)
        }
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_RECEIPT: {
        // TODO:
        let mid = messageProtobuf.getReceipt().array[0]
        let status = messageProtobuf.getReceipt().array[1]
        // console.log('消息回执：送达/已读', mid, status)
        if (uid !== rootState.user.info.uid) {
          // 更新本地消息状态
          commit(types.UPDATE_USER_MESSAGE, { mid, status }, { root: true })
        }
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_RECALL: {
        // TODO: 从聊天记录中删除
        let mid = messageProtobuf.getRecall().array[0]
        // console.log('消息撤回', mid)
        commit(types.DELETE_USER_MESSAGE, { mid }, { root: true })
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_FORM_REQUEST: {
        // 表单消息
        let formContent = messageProtobuf.getExtra().getContent()
        // console.log('notification_form_request', formContent)
        // let formContentObject = JSON.parse(formContent)
        // 发送表单请求
        message.content = formContent
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_FORM_RESULT: {
        // 表单消息
        let formContent = messageProtobuf.getExtra().getContent()
        // notification_form_result {"form":{"realname":"test1","mobile":"13311158888","email":"","age":0,"job":""}}
        // console.log('notification_form_result', formContent)
        // 收到表单结果
        message.content = formContent
        let formContentObject = JSON.parse(formContent)
        // 本地持久化
        // let crm = rootState.user.current_crm
        let crm = Object.assign({}, rootState.user.current_crm)
        crm.name = formContentObject.form.realname.trim().length > 0 ? formContentObject.form.realname : crm.name
        crm.mobile = formContentObject.form.mobile.trim().length > 0 ? formContentObject.form.mobile : crm.mobile
        crm.email = formContentObject.form.email.trim().length > 0 ? formContentObject.form.email : crm.email
        crm.age = formContentObject.form.age > 0 ? formContentObject.form.age : crm.age
        crm.job = formContentObject.form.job.trim().length > 0 ? formContentObject.form.job : crm.job
        commit(types.UPDATE_CURRENT_CUSTOMER_INFO, { crm }, { root: true })
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER: {
        console.log('会话转接')
        if (uid === rootState.user.info.uid) {
          // 提示会话转接发送成功
          bus.$emit(constants.EVENT_BUS_NOTIFICATION_TRANSFER_SENDOK, message)
          return
        }
        //
        let transferMessage = {
          // mid: mid,
          transfer: {
            // topic: messageProtobuf.getTransfer().getTopic(),
            content: messageProtobuf.getTransfer().getContent() // 附言
          },
          thread: thread,
          user: {
            uid: uid,
            nickname: nickname,
            avatar: avatar
          }
        }
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_TRANSFER, transferMessage)
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER_ACCEPT: {
        console.log('接受转接')
        if (uid === rootState.user.info.uid) return
        // TODO: 将thread从本地列表中移除
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_TRANSFER_ACCEPT, message)
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER_REJECT: {
        console.log('拒绝转接')
        if (uid === rootState.user.info.uid) return
        bus.$emit(constants.EVENT_BUS_NOTIFICATION_TRANSFER_REJECT, message)
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_INVITE: {
        console.log('会话邀请')
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_INVITE_ACCEPT: {
        console.log('接受邀请')
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_INVITE_REJECT: {
        console.log('拒绝邀请')
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_INVITE_RATE: {
        console.log('邀请访客评价')
        message.content = messageProtobuf.getExtra().array[0]
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_RATE_RESULT: {
        console.log('访客评价结果通知')
        message.content = messageProtobuf.getExtra().array[0]
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_INVITE_VIDEO: {
        console.log('邀请视频', visitorUid, rootState.user.info.uid)
        if (visitorUid === rootState.user.info.uid) return
        webRTCVideoInvite = true
        message.content = messageProtobuf.getText().array[0]
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_INVITE_AUDIO: {
        console.log('邀请语音', visitorUid, rootState.user.info.uid)
        if (visitorUid === rootState.user.info.uid) return
        webRTCAudioInvite = true
        message.content = messageProtobuf.getText().array[0]
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_CANCEL: {
        console.log('webrtc取消邀请')
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_CANCEL, message)
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_OFFER_VIDEO: {
        console.log('webrtc邀请视频会话', messageProtobuf.getExtra().array[0])
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_OFFER_VIDEO, message)
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_OFFER_AUDIO: {
        console.log('webrtc邀请音频会话')
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_OFFER_AUDIO, message)
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_ANSWER: {
        console.log('接受webrtc邀请', messageProtobuf.getExtra().array[0])
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_ANSWER, message)
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_CANDIDATE: {
        console.log('webrtccandidate信息', messageProtobuf.getExtra().array[0])
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_CANDIDATE, message)
        return
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_ACCEPT: {
        console.log('接受webrtc邀请')
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_ACCEPT, message)
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_REJECT: {
        console.log('拒绝webrtc邀请')
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_REJECT, message)
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_READY: {
        console.log('视频设备 + peeConnection已经就绪')
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_READY, message)
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_BUSY: {
        console.log('webrtc忙线')
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_BUSY, message)
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_CLOSE: {
        console.log('结束webrtc会话')
        if (visitorUid === rootState.user.info.uid) return
        message.content = messageProtobuf.getExtra().array[0]
        bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_CLOSE, message)
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_CREATE: {
        console.log('创建群组')
        break
      }
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_UPDATE:
        console.log('更新群名称、简介等')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_ANNOUNCEMENT:
        console.log('群公告')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_INVITE:
        console.log('邀请多人加入群')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_INVITE_ACCEPT:
        console.log('受邀请：同意')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_INVITE_REJECT:
        console.log('受邀请：拒绝')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_APPLY:
        console.log('主动申请加入群组')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_APPLY_APPROVE:
        console.log('同意：主动申请加群')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_APPLY_DENY:
        console.log('拒绝：主动申请加群')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_KICK:
        console.log('踢人')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_MUTE:
        console.log('禁言')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_TRANSFER:
        console.log('移交群组')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_TRANSFER_ACCEPT:
        console.log('移交群组：同意、接受')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_TRANSFER_REJECT:
        console.log('移交群组：拒绝')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_WITHDRAW:
        console.log('退出群组')
        break
      case constants.MESSAGE_TYPE_NOTIFICATION_GROUP_DISMISS:
        console.log('解散群组')
        break
      case constants.MESSAGE_TYPE_EVENT:
      case constants.MESSAGE_TYPE_CUSTOM:
      case constants.MESSAGE_TYPE_RED_PACKET: {
        console.log('other type')
        break
      }
      default:
        console.log('other message type ', type)
    }
    // console.log('thread: ', thread)
    // console.log('message: ', message)
    // if (!isCloseThread) { // todo: 待放开
    commit(types.ADD_USER_THREAD, { thread }, { root: true })
    // }
    commit(types.ADD_PROTOBUF_MESSAGE, { message }, { root: true })
    //
    if (webRTCVideoInvite) {
      console.log('webRTCVideoInvite')
      // 邀请视频会话
      bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_INVITE_VIDEO, message)
      return
    } else if (webRTCAudioInvite) {
      console.log('webRTCAudioInvite')
      // 邀请音频会话
      bus.$emit(constants.EVENT_BUS_MESSAGE_WEBRTC_INVITE_AUDIO, message)
      return
    }
    // 通知收到新消息
    if (uid !== rootState.user.info.uid) {
      // 非自己发送的消息
      bus.$emit(constants.EVENT_BUS_NEW_MESSAGE, message)
    }
    // 聊天页面滚动到底部
    bus.$emit(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM)
    // 自动回复, 已经迁移到服务器
    // if (autoReply && rootState.user.info.autoReply && uid !== rootState.user.info.uid) {
    //   // 已经迁移到服务器端
    //   let payload = { type: constants.MESSAGE_TYPE_TEXT, content: rootState.user.info.autoReplyContent, thread: thread }
    //   sendMessageProtobuf({ commit, rootState, dispatch }, payload)
    // } else {
    //   console.log('not autoReply', autoReply, rootState.user.info.autoReply)
    // }
    // 发送回执
    if (sendReceipt) {
      // 当前会话 且 非本人发送
      // 针对来自微信公众号和小程序的消息，无需发送回执
      if (message.client === constants.CLIENT_WECHAT_MP || message.client === CLIENT_WECHAT_MINI) {
        return
      }
      // TODO: 需要从接口传入thread等信息
      if (rootState.user.current_thread.topic === thread.topic && uid !== rootState.user.info.uid) {
        // 发送已读状态
        let payload = { mid: mid, status: constants.MESSAGE_STATUS_READ, thread: thread }
        sendMessageReceiptProtobuf({ commit, rootState, dispatch }, payload)
        // 
      } else if (uid !== rootState.user.info.uid) {
        // 非当前会话 且 非本人发送，发送送达状态
        let payload = { mid: mid, status: constants.MESSAGE_STATUS_RECEIVED, thread: thread }
        sendMessageReceiptProtobuf({ commit, rootState, dispatch }, payload)
        // 
      }
    }
  })
  // Emitted after a disconnection.
  mqttClient.on('close', function (error) {
    // if (!constants.IS_PRODUCTION) {
    // console.error('connection closed:', error)
    // }
    mqttConnected = false
    // 更新连接状态: 断开
    let connectionStatus = constants.STOMP_CONNECTION_STATUS_DISCONNECTED
    commit(types.UPDATE_USER_CONNECTION, { connectionStatus }, { root: true })
    bus.$emit(constants.EVENT_BUS_STOMP_CONNECTION_STATUS, connectionStatus)
  })
  // Emitted after receiving disconnect packet from broker. MQTT 5.0 feature.
  mqttClient.on('disconnect', function () {
    // if (!constants.IS_PRODUCTION) {
    console.error('disconnected mqtt')
    // }
    mqttConnected = false
    // 更新连接状态: 断开
    let connectionStatus = constants.STOMP_CONNECTION_STATUS_DISCONNECTED
    commit(types.UPDATE_USER_CONNECTION, { connectionStatus }, { root: true })
    bus.$emit(constants.EVENT_BUS_STOMP_CONNECTION_STATUS, connectionStatus)
  })
  //
  mqttClient.on('offline', function (error) {
    // if (!constants.IS_PRODUCTION) {
    // console.error('offline mqtt:', error)
    // }
    mqttConnected = false
    // 更新连接状态: 断开
    let connectionStatus = constants.STOMP_CONNECTION_STATUS_DISCONNECTED
    commit(types.UPDATE_USER_CONNECTION, { connectionStatus }, { root: true })
    bus.$emit(constants.EVENT_BUS_STOMP_CONNECTION_STATUS, connectionStatus)
  })
  //
  mqttClient.on('error', function (error) {
    // if (!constants.IS_PRODUCTION) {
    // console.error('error mqtt:', error)
    // }
    mqttConnected = false
    // 更新连接状态: 断开
    let connectionStatus = constants.STOMP_CONNECTION_STATUS_DISCONNECTED
    commit(types.UPDATE_USER_CONNECTION, { connectionStatus }, { root: true })
    bus.$emit(constants.EVENT_BUS_STOMP_CONNECTION_STATUS, connectionStatus)
    // mqttClient.end()
  })
  //
  mqttClient.on('reconnect', function () {
    // if (!constants.IS_PRODUCTION) {
    console.log('reconnect mqtt, mqttConnectTimes: ', mqttConnectTimes)
    // }
    // FIXME: 发现重连一定次数之后，就不再重连了
  })
  //
  // mqttClient.end()
  //
}

/**
 * 更新网络连接状态
 */
export const updateMqttNetworkStatus = ({ commit, rootState, dispatch }, payload) => {
  let connectionStatus = payload.status
  if (connectionStatus === constants.NETWORK_CONNECTION_STATUS_CONNECTED) {
    console.log('mqtt network connect')
    // 网络正常
    // networkConnected = true
    mqttConnect({ commit, rootState, dispatch })
  } else {
    console.log('mqtt network disconnect')
    // 网络断开
    mqttConnected = false
    // networkConnected = false
    // 更新连接状态: 断开
    let connectionStatus = constants.STOMP_CONNECTION_STATUS_DISCONNECTED
    commit(types.UPDATE_USER_CONNECTION, { connectionStatus }, { root: true })
    bus.$emit(constants.EVENT_BUS_STOMP_CONNECTION_STATUS, connectionStatus)
  }
}

/**
 *  首先消息插入本地并显示loading，收到回执之后再更新状态
 */
export const sendMessageProtobuf = ({ commit, rootState, dispatch }, payload) => {
  //
  let mid = util.guid()
  let type = payload.type
  let content = payload.content
  let thread = payload.thread
  let localPayload = { mid: mid, content: content, type: type, thread: thread }
  persistLocalMessage({ commit, rootState }, localPayload)
  // 判断是否连接断开
  if (!mqttConnected) {
    // 断开长连接的情况，首先插入本地并显示在界面，TODO: 待重连完毕之后，重新发送
    console.log('disconnected, cant send mqtt message')
    // 长连接已经断开
    // bus.$emit(constants.EVENT_BUS_DISCONNECTED, '')
    // 长链接断开，调用http rest即可消息
    sendMessageJsonRest({ commit, rootState, dispatch }, localPayload)
    return
  }
  // 发送消息
  doSendMessageProtobuf({ commit, rootState, dispatch }, localPayload)
}

// 调用http接口发送消息
export const sendMessageJsonRest = ({ commit, rootState, dispatch }, payload) => {
  //
  let mid = payload.mid
  let type = payload.type
  let content = payload.content
  let thread = payload.thread
  let timestamp = util.currentTimestamp()
  if (type === constants.MESSAGE_TYPE_TEXT) {
    var json = {
      "mid": mid,
      "timestamp": timestamp,
      "client": constants.HTTP_CLIENT,
      "version": "1",
      "type": type,
      "status": constants.MESSAGE_STATUS_SENDING,
      "user": {
        "uid": rootState.user.info.uid,
        "username": rootState.user.info.username,
        "nickname": rootState.user.info.nickname,
        "avatar": rootState.user.info.avatar,
        "extra": {
          "agent": true
        }
      },
      "text": {
        "content": content
      },
      "thread": {
        "tid": thread.tid,
        "type": thread.type,
        "content": content,
        "nickname": thread.nickname,
        "avatar": thread.avatar,
        "topic": thread.topic,
        "client": thread.client,
        "timestamp": timestamp,
        "unreadCount": 0
      }
    }
    // console.log('mqtt send message rest:', JSON.stringify(json))
    let payloadJson = { json: JSON.stringify(json) }
    dispatch('sendMessageRest', payloadJson, { root: true })
  } else if (type === constants.MESSAGE_TYPE_IMAGE) {
    var json = {
      "mid": mid,
      "timestamp": timestamp,
      "client": constants.HTTP_CLIENT,
      "version": "1",
      "type": type,
      "status": constants.MESSAGE_STATUS_SENDING,
      "user": {
        "uid": rootState.user.info.uid,
        "username": rootState.user.info.username,
        "nickname": rootState.user.info.nickname,
        "avatar": rootState.user.info.avatar,
        "extra": {
          "agent": true
        }
      },
      "image": {
        "imageUrl": content
      },
      "thread": {
        "tid": thread.tid,
        "type": thread.type,
        "content": '[图片]',
        "nickname": thread.nickname,
        "avatar": thread.avatar,
        "topic": thread.topic,
        "client": thread.client,
        "timestamp": timestamp,
        "unreadCount": 0
      }
    }
    // console.log('mqtt send message rest:', JSON.stringify(json))
    let payloadJson = { json: JSON.stringify(json) }
    dispatch('sendMessageRest', payloadJson, { root: true })
  } else if (type === constants.MESSAGE_TYPE_FILE) {
    var json = {
      "mid": mid,
      "timestamp": timestamp,
      "client": constants.HTTP_CLIENT,
      "version": "1",
      "type": type,
      "status": constants.MESSAGE_STATUS_SENDING,
      "user": {
        "uid": rootState.user.info.uid,
        "username": rootState.user.info.username,
        "nickname": rootState.user.info.nickname,
        "avatar": rootState.user.info.avatar,
        "extra": {
          "agent": true
        }
      },
      "file": {
        "fileUrl": content
      },
      "thread": {
        "tid": thread.tid,
        "type": thread.type,
        "content": '[文件]',
        "nickname": thread.nickname,
        "avatar": thread.avatar,
        "topic": thread.topic,
        "client": thread.client,
        "timestamp": timestamp,
        "unreadCount": 0
      }
    }
    // console.log('mqtt send message rest:', JSON.stringify(json))
    let payloadJson = { json: JSON.stringify(json) }
    dispatch('sendMessageRest', payloadJson, { root: true })
  } else if (type === constants.MESSAGE_TYPE_VOICE) {
    //
    var json = {
      "mid": mid,
      "timestamp": timestamp,
      "client": constants.HTTP_CLIENT,
      "version": "1",
      "type": type,
      "status": constants.MESSAGE_STATUS_SENDING,
      "user": {
        "uid": rootState.user.info.uid,
        "username": rootState.user.info.username,
        "nickname": rootState.user.info.nickname,
        "avatar": rootState.user.info.avatar,
        "extra": {
          "agent": true
        }
      },
      "voice": {
        "voiceUrl": content,
        "length": '0', // TODO:替换为真实值
        "format": 'wav',
      },
      "thread": {
        "tid": thread.tid,
        "type": thread.type,
        "content": '[语音]',
        "nickname": thread.nickname,
        "avatar": thread.avatar,
        "topic": thread.topic,
        "client": thread.client,
        "timestamp": timestamp,
        "unreadCount": 0
      }
    }
    // console.log('mqtt send message rest:', JSON.stringify(json))
    let payloadJson = { json: JSON.stringify(json) }
    dispatch('sendMessageRest', payloadJson, { root: true })
  } else if (type === constants.MESSAGE_TYPE_VIDEO) {
    //
    var json = {
      "mid": mid,
      "timestamp": timestamp,
      "client": constants.HTTP_CLIENT,
      "version": "1",
      "type": type,
      "status": constants.MESSAGE_STATUS_SENDING,
      "user": {
        "uid": rootState.user.info.uid,
        "username": rootState.user.info.username,
        "nickname": rootState.user.info.nickname,
        "avatar": rootState.user.info.avatar,
        "extra": {
          "agent": true
        }
      },
      "video": {
        "videoOrShortUrl": content,
      },
      "thread": {
        "tid": thread.tid,
        "type": thread.type,
        "content": '[视频]',
        "nickname": thread.nickname,
        "avatar": thread.avatar,
        "topic": thread.topic,
        "client": thread.client,
        "timestamp": timestamp,
        "unreadCount": 0
      }
    }
    // console.log('mqtt send message rest:', JSON.stringify(json))
    let payloadJson = { json: JSON.stringify(json) }
    dispatch('sendMessageRest', payloadJson, { root: true })
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_INVITE_RATE) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_FORM_REQUEST) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_PREVIEW) {
    //
  } else {
    //
  }
}

// 发送已读回执
export const sendMessageReceiptProtobuf = ({ commit, rootState, dispatch }, payload) => {
  // 发送已读状态
  let localPayload = {
    type: constants.MESSAGE_TYPE_NOTIFICATION_RECEIPT,
    content: { mid: payload.mid, status: payload.status },
    thread: payload.thread
  }
  sendMessageProtobuf({ commit, rootState, dispatch }, localPayload)
}

// 发送选择问题消息
export const sendMessageChoiceProtobuf = ({ commit, rootState, dispatch }, payload) => {
  // 发送
  let localPayload = {
    type: constants.MESSAGE_TYPE_CHOICE,
    content: { content: payload.content, choices: payload.choices },
    thread: payload.thread
  }
  sendMessageProtobuf({ commit, rootState, dispatch }, localPayload)
}

// TODO: 发送表单问卷消息
// export const sendMessageSurveyProtobuf = ({ commit, rootState, dispatch }, payload) => {
//   // 发送
//   let localPayload = {
//     type: constants.MESSAGE_TYPE_SURVEY,
//     content: { content: payload.content, choices: payload.choices },
//     thread: payload.thread
//   }
//   sendMessageProtobuf({ commit, rootState, dispatch }, localPayload)
// }

// 持久化-客服自己发送的消息
export const persistLocalMessage = ({ commit, rootState }, localPayload) => {
  // 仅持久化下面几种消息类型
  let type = localPayload.type
  if (type === constants.MESSAGE_TYPE_TEXT ||
    type === constants.MESSAGE_TYPE_IMAGE ||
    type === constants.MESSAGE_TYPE_VOICE ||
    type === constants.MESSAGE_TYPE_FILE) {
    //
    let content = localPayload.content
    let currentThread = localPayload.thread
    let mid = localPayload.mid
    // 本地持久化
    let message = {
      mid: mid,
      content: content,
      imageUrl: content,
      voiceUrl: content,
      // video
      videoOrShortUrl: content,
      // file
      fileUrl: content,
      // location
      lablel: '',
      scale: '',
      locationX: '',
      locationY: '',
      // link
      title: '',
      description: '',
      url: '',
      //
      createdAt: util.currentTimestamp(),
      client: constants.HTTP_CLIENT,
      type: type,
      status: constants.MESSAGE_STATUS_SENDING,
      thread: currentThread,
      user: {
        uid: rootState.user.info.uid,
        nickname: rootState.user.info.nickname,
        avatar: rootState.user.info.avatar
      }
    }
    commit(types.ADD_PROTOBUF_MESSAGE, { message }, { root: true })
    // 聊天页面滚动到底部
    bus.$emit(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM)
  }
}

// 发送消息
export const doSendMessageProtobuf = ({ commit, rootState, dispatch }, localPayload) => {
  console.log('doSendMessageProtobuf:', localPayload)
  //
  let mid = localPayload.mid
  let content = localPayload.content
  console.log('content', content)
  let type = localPayload.type
  let currentThread = localPayload.thread
  if (currentThread.closed) {
    // 会话已经结束，有可能是客服给历史会话中访客发送消息，需要添加订阅
    let thread = currentThread
    dispatch('restartThread', thread, { root: true })
  }
  let timestamp = util.currentTimestamp()
  // thread
  let thread = new messageProto.Thread()
  thread.setTid(currentThread.tid)
  thread.setType(currentThread.type)
  thread.setTopic(currentThread.topic)
  thread.setNickname(currentThread.nickname)
  thread.setAvatar(currentThread.avatar)
  thread.setClient(currentThread.client)
  thread.setTimestamp(timestamp)
  thread.setUnreadcount(0)
  // thread设置置顶、未读
  let threadExtra = { top: currentThread.top, nodisturb: currentThread.nodisturb }
  thread.setExtra(JSON.stringify(threadExtra));
  // user
  let user = new messageProto.User()
  user.setUid(rootState.user.info.uid)
  user.setUsername(rootState.user.info.username)
  user.setNickname(rootState.user.info.nickname)
  user.setAvatar(rootState.user.info.avatar)
  // 标记为客服账号
  let userExtra = { agent: true }
  user.setExtra(JSON.stringify(userExtra))
  // message
  let message = new messageProto.Message()
  message.setMid(mid)
  message.setType(type)
  message.setTimestamp(timestamp)
  message.setClient(constants.HTTP_CLIENT)
  message.setVersion('1')
  message.setEncrypted(false)
  //
  console.log('content 1', content, type)
  if (type === constants.MESSAGE_TYPE_TEXT) {
    let text = new messageProto.Text()
    // 加密消息内容
    // text.setContent(util.encrypt(content))
    text.setContent(content)
    message.setText(text)
    //
    thread.setContent(content)
  } else if (type === constants.MESSAGE_TYPE_IMAGE) {
    let image = new messageProto.Image()
    image.setImageurl(content)
    message.setImage(image)
    //
    thread.setContent('[图片]')
  } else if (type === constants.MESSAGE_TYPE_VOICE) {
    let voice = new messageProto.Voice()
    voice.setVoiceurl(content)
    message.setVoice(voice)
    //
    thread.setContent('[语音]')
  } else if (type === constants.MESSAGE_TYPE_VIDEO) {
    let video = new messageProto.Video()
    video.setVideoorshorturl(content)
    message.setVideo(video)
    //
    thread.setContent('[视频]')
  } else if (type === constants.MESSAGE_TYPE_CARD) {
    // 卡片消息
    let text = new messageProto.Text()
    text.setContent(content)
    message.setText(text)
    //
    thread.setContent(content)
  } else if (type === constants.MESSAGE_TYPE_FILE) {
    let file = new messageProto.File()
    file.setFileurl(content)
    message.setFile(file)
    //
    thread.setContent('[文件]')
  } else if (type === constants.MESSAGE_TYPE_CHOICE) {
    //
    let choiceContent = localPayload.content.content
    let choices = localPayload.content.choices
    // 选择
    let text = new messageProto.Text()
    text.setContent(choiceContent)
    message.setText(text)
    //
    let extra = new messageProto.Extra()
    extra.setContent(choices)
    message.setExtra(extra)
    //
    thread.setContent('[选择问题]')
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_PREVIEW) {
    // 预览消息
    let preview = new messageProto.Preview()
    preview.setContent(content)
    message.setPreview(preview)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_RECEIPT) {
    // 送达/已读
    let mid = localPayload.content.mid
    let status = localPayload.content.status
    let receipt = new messageProto.Receipt()
    receipt.setMid(mid)
    receipt.setStatus(status)
    message.setReceipt(receipt)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_RECALL) {
    // 撤回
    let mid = content
    let recall = new messageProto.Recall()
    recall.setMid(mid)
    message.setRecall(recall)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_FORM_REQUEST) {
    // 表单请求
    let extra = new messageProto.Extra()
    extra.setContent(content)
    message.setExtra(extra)
    //
    thread.setContent('[表单]')
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER) {
    // FIXME: 此处 content 为什么为undefined?
    console.log('MESSAGE_TYPE_NOTIFICATION_TRANSFER', content, localPayload.content)
    // 会话转接
    let topic = localPayload.content.topic
    let content = localPayload.content.content
    let transfer = new messageProto.Transfer()
    transfer.setTopic(topic)
    transfer.setContent(content)
    message.setTransfer(transfer)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER_ACCEPT) {
    // 接受转接
    let topic = content.topic
    let transfer = new messageProto.Transfer()
    transfer.setTopic(topic)
    transfer.setAccept(true)
    message.setTransfer(transfer)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER_REJECT) {
    // 拒绝转接
    let topic = content.topic
    let transfer = new messageProto.Transfer()
    transfer.setTopic(topic)
    transfer.setAccept(false)
    message.setTransfer(transfer)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_INVITE) {
    // 会话邀请
    let topic = content.topic
    let content = content.content
    let invite = new messageProto.Invite()
    invite.setTopic(topic)
    invite.setContent(content)
    message.setInvite(invite)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_INVITE_ACCEPT) {
    // 接受邀请
    let topic = content.topic
    let invite = new messageProto.Invite()
    invite.setTopic(topic)
    invite.setAccept(true)
    message.setInvite(invite)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_INVITE_REJECT) {
    // 拒绝邀请
    let topic = content.topic
    let invite = new messageProto.Invite()
    invite.setTopic(topic)
    invite.setAccept(false)
    message.setInvite(invite)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_INVITE_RATE) {
    // 邀请访客评价
    let extra = new messageProto.Extra()
    extra.setContent(content)
    message.setExtra(extra)
    //
    thread.setContent(content)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_OFFER_VIDEO) {
    // 邀请视频
    let extra = new messageProto.Extra()
    extra.setContent(content)
    message.setExtra(extra)
    //
    thread.setContent('邀请视频')
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_OFFER_AUDIO) {
    // 邀请音频
    let extra = new messageProto.Extra()
    extra.setContent(content)
    message.setExtra(extra)
    //
    thread.setContent('邀请音频')
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_ANSWER ||
    type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_CANDIDATE ||
    type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_ACCEPT ||
    type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_REJECT ||
    type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_READY ||
    type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_BUSY ||
    type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_CLOSE ||
    type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_CANCEL) {
    //
    let extra = new messageProto.Extra()
    extra.setContent(content)
    message.setExtra(extra)
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_CREATE) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_UPDATE) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_ANNOUNCEMENT) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_INVITE) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_INVITE_ACCEPT) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_INVITE_REJECT) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_APPLY) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_APPLY_APPROVE) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_APPLY_DENY) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_KICK) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_MUTE) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_TRANSFER) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_TRANSFER_ACCEPT) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_TRANSFER_REJECT) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_WITHDRAW) {
    //
  } else if (type === constants.MESSAGE_TYPE_NOTIFICATION_GROUP_DISMISS) {
    //
  } else {
    let text = new messageProto.Text()
    text.setContent(content)
    message.setText(text)
    //
    thread.setContent(content)
  }
  //
  message.setUser(user)
  message.setThread(thread)
  //
  var messageBytes = message.serializeBinary()
  mqttClient.publish(currentThread.topic, messageBytes, {
    qos: 1,
    retain: true
  })
  // console.log('do send mqtt message: ', localPayload)
}

// 发通知
export const sendNoticeProtobuf = ({ commit, rootState }, payload) => {
  //
  if (!mqttConnected) {
    // TODO: 通知界面
    console.log('disconnected, cant send notice')
    return
  }
  console.log('do send mqtt notice: ', payload)
  let topic = payload.topic
  let content = payload.content
  let type = payload.type
  // user
  let user = new messageProto.User()
  user.setUid(rootState.user.info.uid)
  user.setUsername(rootState.user.info.username)
  user.setNickname(rootState.user.info.nickname)
  user.setAvatar(rootState.user.info.avatar)
  //
  let notice = new messageProto.Notice()
  notice.setTopic(topic)
  notice.setType(type)
  notice.setContent(content)
  // message
  let message = new messageProto.Message()
  message.setMid(util.guid())
  message.setType(constants.MESSAGE_TYPE_NOTIFICATION_NOTICE)
  message.setTimestamp(util.currentTimestamp())
  message.setClient(constants.HTTP_CLIENT)
  message.setVersion('1')
  message.setEncrypted(false)
  //
  message.setNotice(notice)
  message.setUser(user)
  //
  var messageBytes = message.serializeBinary()
  mqttClient.publish(topic, messageBytes, {
    qos: 1,
    retain: true
  })
}

export const mqttSubscribe = ({ commit, rootState }, topic) => {
  // 订阅
  if (mqttClient) {
    mqttClient.subscribe(topic, { qos: 0 })
  }
  // mqttClient.subscribe('presence', function (error) {
  //   if (!error) {
  //     console.log('subscribe success')
  //     const message = JSON.stringify({'type': 'text', 'content': 'Hello World', 'client': 'web'})
  //     mqttClient.publish('presence', message)
  //   } else {
  //     console.log('subscribe error: ', error)
  //   }
  // })
}

export const mqttUnsubscribe = ({ commit, rootState }, topic) => {
  //
  if (mqttClient) {
    mqttClient.unsubscribe(topic)
  }
}

export const mqttDisconnect = ({ commit, rootState }) => {
  //
  if (mqttClient) {
    mqttClient.end()
  }
}

// export const updateNoteMap = ({ commit, rootState }) => {
// }


// 增加外部自定义mid
// export const sendMessageProtobuf2 = ({ commit, rootState, dispatch }, payload) => {
//   //
//   let mid = payload.mid
//   let localPayload = { mid: mid, content: payload.content, type: payload.type, thread: payload.thread }
//   persistLocalMessage({ commit, rootState }, localPayload)
//   // 发送消息
//   doSendMessageProtobuf({ commit, rootState, dispatch }, localPayload)
//   // 判断是否连接断开
//   if (!mqttConnected) {
//     // 断开长连接的情况，首先插入本地并显示在界面，TODO: 待重连完毕之后，重新发送
//     console.log('disconnected, cant send message')
//     // 长连接已经断开
//     bus.$emit(constants.EVENT_BUS_DISCONNECTED, '')
//     // TODO: 长链接断开，调用http rest即可消息
//     return
//   }
// }
